import ModernApplicationDevelopment from './ModernApplicationDevelopment'

export default ModernApplicationDevelopment
